import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'cmv-wave',
	templateUrl: './wave.component.html',
	styleUrls: ['./wave.component.scss'],
})
export class WaveComponent {
	constructor() {}
}
